"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_app_button_1 = require("@campgladiator/cgui-core.atoms.app-button");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_logo_1 = require("@campgladiator/cgui-core.atoms.logo");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const cgui_core_utilities_helpers_links_1 = require("@campgladiator/cgui-core.utilities.helpers.links");
const cgui_core_utilities_helpers_resolution_variables_1 = require("@campgladiator/cgui-core.utilities.helpers.resolution-variables");
const cgui_core_utilities_hooks_use_device_width_1 = require("@campgladiator/cgui-core.utilities.hooks.use-device-width");
const grid = __importStar(require("@campgladiator/cgui-core.styles.helpers.grid"));
const footerData_1 = require("./footerData");
const footer_module_scss_1 = __importDefault(require("./footer.module.scss"));
const NavItem = ({ nav }) => (react_1.default.createElement("li", { className: footer_module_scss_1.default.item },
    react_1.default.createElement("a", { className: footer_module_scss_1.default.link, href: nav.link, target: (0, cgui_core_utilities_helpers_links_1.setHrefTarget)(nav.link) },
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { className: footer_module_scss_1.default.text, size: "xsmall", weight: "book" }, nav.text))));
const NavColumn = ({ title, links }) => (react_1.default.createElement("div", { className: footer_module_scss_1.default.navList },
    react_1.default.createElement("nav", { className: footer_module_scss_1.default.nav },
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: footer_module_scss_1.default.columnHeader }, title),
        react_1.default.createElement("ul", { className: footer_module_scss_1.default.list }, links.map((nav) => (react_1.default.createElement(NavItem, { nav: nav, key: nav.link + nav.text })))))));
const Social = ({ items }) => (react_1.default.createElement("div", { className: footer_module_scss_1.default.followDownload },
    react_1.default.createElement("div", { className: footer_module_scss_1.default.social },
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: footer_module_scss_1.default.columnHeader }, "Follow"),
        react_1.default.createElement("ul", { className: footer_module_scss_1.default.list }, items.map(({ link, title, icon }) => (react_1.default.createElement("li", { className: footer_module_scss_1.default.item, key: icon + link },
            react_1.default.createElement("a", { href: link, target: "_blank", title: title, className: footer_module_scss_1.default.link },
                react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { name: icon, className: footer_module_scss_1.default.icon })))))))));
const Downloads = ({ downloads }) => (react_1.default.createElement("div", { className: footer_module_scss_1.default.followDownload },
    react_1.default.createElement("div", { className: footer_module_scss_1.default.downloads },
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", className: footer_module_scss_1.default.columnHeader }, "Download"),
        react_1.default.createElement("div", { className: footer_module_scss_1.default.buttons }, downloads.map(({ name, brand, size, theme }) => (react_1.default.createElement(cgui_core_atoms_app_button_1.AppButton, { key: name + brand, title: name, brand: brand, size: size, theme: theme })))))));
const Footnote = () => {
    const year = new Date().getFullYear();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: grid.col12 },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(footer_module_scss_1.default.footnote, grid.col12) })),
        react_1.default.createElement("div", { className: grid.colLg2 }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(footer_module_scss_1.default.termsPrivacy, grid.col12, grid.colMd6, grid.colLg5) }, footerData_1.footnoteLinks.map(({ link, text }) => (react_1.default.createElement("a", { href: link, target: (0, cgui_core_utilities_helpers_links_1.setHrefTarget)(link), className: footer_module_scss_1.default.link, key: link + text },
            react_1.default.createElement(cgui_core_atoms_typography_1.Label, { size: "xsmall" }, text))))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(footer_module_scss_1.default.copyright, grid.col12, grid.colMd6, grid.colLg5) },
            react_1.default.createElement(cgui_core_atoms_typography_1.Label, { size: "xsmall", className: footer_module_scss_1.default.text },
                "\u00A9 ",
                year,
                " Camp Gladiator. All rights reserved."))));
};
const FooterLogo = () => (react_1.default.createElement("div", { className: footer_module_scss_1.default.logoWrapper },
    react_1.default.createElement("a", { href: footerData_1.logoNav.link, target: (0, cgui_core_utilities_helpers_links_1.setHrefTarget)(footerData_1.logoNav.link) },
        react_1.default.createElement(cgui_core_atoms_logo_1.Logo, { type: "icon", iconType: "white", width: "50px", className: footer_module_scss_1.default.logo }))));
const WorkoutProgram = () => (react_1.default.createElement(NavColumn, { title: "Workout Program", links: footerData_1.workoutProgramNav }));
const Nutrition = () => react_1.default.createElement(NavColumn, { title: "Nutrition", links: footerData_1.nutritionNav });
const Trainers = () => react_1.default.createElement(NavColumn, { title: "Trainers", links: footerData_1.trainersNav });
const Company = () => react_1.default.createElement(NavColumn, { title: "Company", links: footerData_1.companyNav });
const Shop = () => react_1.default.createElement(NavColumn, { title: "Shop", links: footerData_1.shopNav });
const Help = () => react_1.default.createElement(NavColumn, { title: "Help", links: footerData_1.helpNav });
const LargeFooterLists = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(FooterLogo, null)),
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(WorkoutProgram, null)),
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(Nutrition, null)),
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(Trainers, null)),
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(Company, null)),
    react_1.default.createElement("div", { className: grid.colLg2 },
        react_1.default.createElement(Shop, null),
        react_1.default.createElement(Help, null))));
const FooterListsMedium = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: grid.col2 },
        react_1.default.createElement(FooterLogo, null)),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(WorkoutProgram, null)),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(Nutrition, null)),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(Trainers, null)),
    react_1.default.createElement("div", { className: grid.col2 }),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(Company, null)),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(Shop, null)),
    react_1.default.createElement("div", { className: grid.col3 },
        react_1.default.createElement(Help, null))));
const FooterListsSmall = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: grid.col12 },
        react_1.default.createElement(FooterLogo, null)),
    react_1.default.createElement("div", { className: grid.col6 },
        react_1.default.createElement(WorkoutProgram, null)),
    react_1.default.createElement("div", { className: grid.col6 },
        react_1.default.createElement(Nutrition, null),
        react_1.default.createElement(Trainers, null)),
    react_1.default.createElement("div", { className: grid.col6 },
        react_1.default.createElement(Company, null)),
    react_1.default.createElement("div", { className: grid.col6 },
        react_1.default.createElement(Shop, null),
        react_1.default.createElement(Help, null))));
const FooterLists = () => {
    const deviceWidth = (0, cgui_core_utilities_hooks_use_device_width_1.useDeviceWidth)();
    if (deviceWidth > cgui_core_utilities_helpers_resolution_variables_1.breakpoints.tabletLarge)
        return react_1.default.createElement(LargeFooterLists, null);
    if (deviceWidth > cgui_core_utilities_helpers_resolution_variables_1.breakpoints.tabletMedium)
        return react_1.default.createElement(FooterListsMedium, null);
    return react_1.default.createElement(FooterListsSmall, null);
};
const Footer = (_a) => {
    var { className = "" } = _a, props = __rest(_a, ["className"]);
    return (react_1.default.createElement("footer", Object.assign({ className: (0, classnames_1.default)(footer_module_scss_1.default.footer, className) }, props),
        react_1.default.createElement("div", { className: grid.container },
            react_1.default.createElement("div", { className: grid.row },
                react_1.default.createElement(FooterLists, null)),
            react_1.default.createElement("div", { className: grid.row },
                react_1.default.createElement("div", { className: grid.col2 }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(grid.col12, grid.colMd4, grid.colLg5) },
                    react_1.default.createElement(Social, { items: footerData_1.socialList })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(grid.col12, grid.colMd6, grid.colLg5) },
                    react_1.default.createElement(Downloads, { downloads: footerData_1.appDownloads }))),
            react_1.default.createElement("div", { className: grid.row },
                react_1.default.createElement(Footnote, null)))));
};
exports.default = (0, react_1.memo)(Footer);
//# sourceMappingURL=footer.js.map